module.exports = __webpack_public_path__ + "img/icon-user-job-title.2fc3d36e.svg";